export const LOAD_INITIAL_STATE = 'LOAD_INITIAL_STATE';
export const LOGOUT = 'LOGOUT';
export const SAVE_SUBSCRIPTION = 'SAVE_SUBSCRIPTION';
export const SAVE_NOTIFICATIONS_SUPPORT = 'SAVE_NOTIFICATIONS_SUPPORT';
export const SAVE_NOTIFICATIONS_ALLOWED = 'SAVE_NOTIFICATIONS_ALLOWED';
export const SAVE_BROWSER_SPECTS = 'SAVE_BROWSER_SPECTS';
export const UPDATE_SUBSCRIPTION = 'UPDATE_SUBSCRIPTION';
export const VERIFY_SUBSCRIPTION = 'VERIFY_SUBSCRIPTION';
export const VALIDATE_VERSION = 'VALIDATE_VERSION';




// WEBPACK FOOTER //
// ./src/store/actionTypes.js